import { useState } from 'react';
import { NotificationType } from '../components/common/NotificationModal';

interface NotificationState {
  isOpen: boolean;
  type: NotificationType;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  showCancel?: boolean;
}

export const useNotification = () => {
  const [notification, setNotification] = useState<NotificationState>({
    isOpen: false,
    type: 'info',
    title: '',
    message: ''
  });

  const showNotification = (
    type: NotificationType,
    title: string,
    message: string,
    options?: {
      confirmText?: string;
      cancelText?: string;
      onConfirm?: () => void;
      showCancel?: boolean;
    }
  ) => {
    setNotification({
      isOpen: true,
      type,
      title,
      message,
      ...options
    });
  };

  const closeNotification = () => {
    setNotification(prev => ({ ...prev, isOpen: false }));
  };

  // Convenience methods
  const showSuccess = (title: string, message: string, onConfirm?: () => void) => {
    showNotification('success', title, message, { onConfirm });
  };

  const showError = (title: string, message: string, onConfirm?: () => void) => {
    showNotification('error', title, message, { onConfirm });
  };

  const showWarning = (title: string, message: string, onConfirm?: () => void) => {
    showNotification('warning', title, message, { onConfirm });
  };

  const showInfo = (title: string, message: string, onConfirm?: () => void) => {
    showNotification('info', title, message, { onConfirm });
  };

  const showConfirm = (
    title: string,
    message: string,
    onConfirm: () => void,
    confirmText = 'Igen',
    cancelText = 'Nem'
  ) => {
    showNotification('warning', title, message, {
      onConfirm,
      showCancel: true,
      confirmText,
      cancelText
    });
  };

  return {
    notification,
    showNotification,
    closeNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showConfirm
  };
}; 